import {axiosGet, urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";
import SelectAbleUserFilterMixin from "./SelectAbleUserFilterMixin";
import {DepartmentFilterMixin, UserFilterMixin} from "./FilterMixin";

export default {
    mixins: [DepartmentFilterMixin, SelectAbleUserFilterMixin, UserFilterMixin, DatatableHelperMixin],
    data() {
        return {
            urlGenerator,
            options: {
                name             : this.$t('daily_report'),
                url              : `${TENANT_BASE_URL}app/daily-report/list`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('user'),
                        type     : 'custom-html',
                        key      : 'user',
                        isVisible: true,
                        modifier : (value) => {
                            return value.full_name;
                        }
                    },
                    {
                        title    : this.$t('report_date'),
                        type     : 'custom-html',
                        key      : 'report_date',
                        isVisible: true,
                        modifier : (value) => {
                            return formatDateToLocal(value);
                        }
                    },
                    {
                        title    : this.$t('status'),
                        type     : 'custom-html',
                        key      : 'status_name',
                        isVisible: true,
                        modifier : (data, row) => {
                            if (row.status === 'rejected') {
                                return '<div class="badge badge-pill badge-secondary">' + data + '</div>';
                            }
                            if (row.status === 'submitted') {
                                return '<div class="badge badge-pill badge-success">' + data + '</div>';
                            }
                            if (row.status === 'reviewed') {
                                return '<div class="badge badge-pill badge-warning">' + data + '</div>';
                            }
                            return '<div class="badge badge-pill badge-primary">' + data + '</div>';
                        }
                    },
                    {
                        title    : this.$t('comments'),
                        type     : 'text',
                        key      : 'comments_count',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('created'),
                        type     : 'text',
                        key      : 'created_ago',
                        isVisible: true,
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('department'),
                        type          : 'multi-select-filter',
                        key           : 'departments',
                        listValueField: 'name',
                        option        : [],
                        permission    : !!this.$can('view_departments')
                    },
                    {
                        title         : this.$t('users'),
                        type          : "multi-select-filter",
                        key           : "users",
                        option        : [],
                        listValueField: 'employee_name',
                        permission    : !!this.$can('view_all_attendance') && !!this.$can('view_users')
                    },
                    {
                        title : this.$t('created'),
                        type  : "range-picker",
                        key   : "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title         : this.$t('status'),
                        type          : "multi-select-filter",
                        key           : "status",
                        option        : [],
                        listValueField: 'name',
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [
                    {
                        title   : this.$t('detail'),
                        icon    : 'eye',
                        type    : 'modal',
                        modifier: row => this.$can('update_daily_report')
                    },
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_daily_report')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/daily-report/list`,
                        name     : 'delete',
                        modifier : row => this.$can('delete_daily_report')
                    }
                ],
            }
        }
    },
    mounted() {
        const statusFilter = this.options.filters.find(item => item.key === 'status');

        axiosGet(`${TENANT_BASE_URL}api/daily-report/status`)
            .then(({data}) => statusFilter.option = data)
            .catch(error => this.$toastr.e(error.response.data.message))
    },
}
